import { useState } from "react";
import { api, apiError } from "../lib/api";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { fmtDateTime } from "../lib/dates";
import { MessageSquare, Send, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function StudyMessages({ b, onReload, meRole }) {
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);
  const messages = b.messages || [];

  const send = async () => {
    if (!text.trim()) return;
    setSending(true);
    try {
      await api.post(`/bookings/${b.id}/messages`, { text: text.trim() });
      setText("");
      onReload();
    } catch (e) { toast.error(apiError(e)); }
    finally { setSending(false); }
  };

  return (
    <div className="mt-4 pt-3 border-t border-slate-100" data-testid={`messages-${b.id}`}>
      <p className="text-xs font-bold text-[#64748B] uppercase mb-2 flex items-center gap-1.5">
        <MessageSquare className="h-3.5 w-3.5" />Conversación{messages.length > 0 ? ` (${messages.length})` : ""}
      </p>
      <div className="space-y-2 mb-3">
        {messages.length === 0 && <p className="text-sm text-slate-400">Aún no hay mensajes. Escribe el primero.</p>}
        {messages.map((m) => {
          const isAdmin = m.sender_role === "admin";
          return (
            <div key={m.id} className={`flex ${isAdmin ? "justify-start" : "justify-end"}`} data-testid={`message-${m.id}`}>
              <div className={`max-w-[85%] rounded-2xl px-3.5 py-2 ${isAdmin ? "bg-[#373E45] text-white" : "bg-[#7FD498]/25 text-[#373E45] border border-[#7FD498]/40"}`}>
                <p className={`text-[11px] font-bold mb-0.5 ${isAdmin ? "text-white/60" : "text-[#5a8a68]"}`}>
                  {isAdmin ? "Veterinario" : (m.sender_name || "Clínica")} · {fmtDateTime(m.created_at)}
                </p>
                <p className="text-sm whitespace-pre-wrap leading-relaxed">{m.text}</p>
              </div>
            </div>
          );
        })}
      </div>
      <div className="flex items-end gap-2">
        <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={2}
          placeholder={meRole === "admin" ? "Escribe un mensaje para la clínica…" : "Escribe una respuesta al veterinario…"}
          className="bg-slate-50 focus-visible:ring-[#7FD498] resize-none" data-testid={`message-input-${b.id}`} />
        <Button onClick={send} disabled={sending || !text.trim()} className="bg-[#7FD498] hover:bg-[#6BC284] text-[#373E45] font-bold rounded-xl shrink-0" data-testid={`message-send-${b.id}`}>
          {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
        </Button>
      </div>
    </div>
  );
}
